module.exports = __webpack_public_path__ + "img/list.4e1aa9b2.png";